export class EpochData {
    epoch;
    acknowledged;
    constructor(epoch, acknowledged) {
        this.epoch = epoch;
        this.acknowledged = acknowledged;
    }
}
export const DEFAULT_EPOCH_DATA = new EpochData(0n, true);
export const KEY_STORE_EPOCH = 'epoch';
